import { List } from './List'
import React from 'react'

export const MetadataInput = () => {
  return <List />
}
